import { cn } from '@module/lib/utils';
import type { HTMLProps } from 'react';

interface Props extends HTMLProps<HTMLElement> {}

function MainTitle(props: Props) {
  const { className, ...rest } = props;
  return (
    <strong className={cn('line mb-6 block font-bold text-[24px] text-colorFg02 leading-[28px]', className)} {...rest}>
      {props?.children}
    </strong>
  );
}

export default MainTitle;
